// extracted by mini-css-extract-plugin
export default {"extraContainer":"styles_extraContainer__7oWTP"};